import { render } from "./VideoModal.vue?vue&type=template&id=4f266e4e"
import script from "./VideoModal.vue?vue&type=script&lang=js"
export * from "./VideoModal.vue?vue&type=script&lang=js"

import "./VideoModal.vue?vue&type=style&index=0&id=4f266e4e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__